'use strict';

var $ = require('jquery');
var Backbone = require('backbone');

export default Backbone.View.extend({

  tagName: 'input',

  attributes: {
    type: 'text',
  },

  initialize: function (options) {
    this.responseId = options.responseId;
    this.question = options.question;
    this.answer = options.answer;
  },

  render: function () {
    this.$el.prop('id', this.question.get('id'));
    this.$el.prop('name', this.responseId);

    if (this.question.get('placeholder')) {
      this.$el.prop('placeholder', this.question.get('placeholder'));
    }

    if (this.question.get('required')) {
      this.$el.prop('required', true);
    }

    if (this.answer) {
      this.$el.val(this.answer);
    }

    return this;
  },
});
